import { create } from "zustand";

type State = {
  search: string;
};

type Action = {
  setSearch: (trigger: State["search"]) => void;
};

const useSearchAllCourses = create<State & Action>((set) => ({
  search: "",
  setSearch: (newSearch) => set(() => ({ search: newSearch })),
}));

export default useSearchAllCourses;
